// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dNumber from "../Data.Number/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrd$dGeneric from "../Data.Ord.Generic/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dVatRate from "../Restaumatic.Menu.V2.Types.VatRate/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $CartPromotionRequirement = (tag, _1) => ({tag, _1});
const $ProductSingleFilter = (tag, _1, _2) => ({tag, _1, _2});
const $PromotionConditions = (tag, _1) => ({tag, _1});
const $PromotionFilter = _1 => ({tag: "PromotionIdFilter", _1});
const $PromotionPrize = (tag, _1) => ({tag, _1});
const $PromotionTarget = tag => ({tag});
const $PromotionType = tag => ({tag});
const eq = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqIntImpl);
const eq1 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(Restaumatic$dMenu$dV2$dTypes$dItemId.eqItemId.eq))();
const eq2 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const compare = /* #__PURE__ */ (() => Data$dOrd.ordArray(Restaumatic$dMenu$dV2$dTypes$dItemId.ordItemId).compare)();
const compare1 = /* #__PURE__ */ (() => Data$dOrd.ordArray(Data$dOrd.ordString).compare)();
const StandardIsSymbol = {reflectSymbol: () => "Standard"};
const InformationOnlyIsSymbol = {reflectSymbol: () => "InformationOnly"};
const RequiresCouponIsSymbol = {reflectSymbol: () => "RequiresCoupon"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericBottomSum = {"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
const genericEnumSum1 = /* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor);
const genericEnumSum2 = /* #__PURE__ */ genericEnumSum(genericEnumSum1)(genericBottomSum);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum2 = /* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumSum1);
const CartTargetIsSymbol = {reflectSymbol: () => "CartTarget"};
const ProductTargetIsSymbol = {reflectSymbol: () => "ProductTarget"};
const PromotionIdFilterIsSymbol = {reflectSymbol: () => "PromotionIdFilter"};
const ItemIdFilterIsSymbol = {reflectSymbol: () => "ItemIdFilter"};
const genericShowArgsArgument = /* #__PURE__ */ (() => {
  const $0 = Data$dShow.showArrayImpl(Data$dUUID.toString);
  return {genericShowArgs: v => [$0(v)]};
})();
const ProductCategoryIdFilterIsSymbol = {reflectSymbol: () => "ProductCategoryIdFilter"};
const ParameterValueFilterIsSymbol = {reflectSymbol: () => "ParameterValueFilter"};
const AnyComboFilterIsSymbol = {reflectSymbol: () => "AnyComboFilter"};
const decodeArray1 = /* #__PURE__ */ (() => ({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)}))();
const numRequiredItemsIsSymbol = {reflectSymbol: () => "numRequiredItems"};
const productFilterIsSymbol = {reflectSymbol: () => "productFilter"};
const repeatableIsSymbol = {reflectSymbol: () => "repeatable"};
const ProductPromotionRequirementsIsSymbol = {reflectSymbol: () => "ProductPromotionRequirements"};
const productNameIsSymbol = {reflectSymbol: () => "productName"};
const productValueIsSymbol = {reflectSymbol: () => "productValue"};
const vatRateIsSymbol = {reflectSymbol: () => "vatRate"};
const FreeProductIsSymbol = {reflectSymbol: () => "FreeProduct"};
const FreebyIsSymbol = {reflectSymbol: () => "Freeby"};
const PercentageDiscountIsSymbol = {reflectSymbol: () => "PercentageDiscount"};
const PriceDiscountIsSymbol = {reflectSymbol: () => "PriceDiscount"};
const CouponValueIsSymbol = {reflectSymbol: () => "CouponValue"};
const TextInformationIsSymbol = {reflectSymbol: () => "TextInformation"};
const minCartValueIsSymbol = {reflectSymbol: () => "minCartValue"};
const genericOrdConstructor = {"genericCompare'": v => v1 => Data$dOrdering.EQ};
const CartValueIsSymbol = {reflectSymbol: () => "CartValue"};
const FirstOrderIsSymbol = {reflectSymbol: () => "FirstOrder"};
const LoyaltyIsSymbol = {reflectSymbol: () => "Loyalty"};
const HasCouponIsSymbol = {reflectSymbol: () => "HasCoupon"};
const AlwaysIsSymbol = {reflectSymbol: () => "Always"};
const NeverIsSymbol = {reflectSymbol: () => "Never"};
const CartPromotionIsSymbol = {reflectSymbol: () => "CartPromotion"};
const ProductPromotionIsSymbol = {reflectSymbol: () => "ProductPromotion"};
const genericEncodeArgsArgument = /* #__PURE__ */ (() => {
  const encode1 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
  return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encode1(v)), Data$dList$dTypes.Nil)};
})();
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther1 = {encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode};
const genericDecodeArgsArgument = {
  decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID).decode;
    return {decodeWithOptions: v => decode2};
  })()),
  decodeSingleRecordArg: Data$dMaybe.Nothing
};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const decodeWithOptionsOther1 = {decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode};
const Standard = /* #__PURE__ */ $PromotionType("Standard");
const InformationOnly = /* #__PURE__ */ $PromotionType("InformationOnly");
const RequiresCoupon = /* #__PURE__ */ $PromotionType("RequiresCoupon");
const CartTarget = /* #__PURE__ */ $PromotionTarget("CartTarget");
const ProductTarget = /* #__PURE__ */ $PromotionTarget("ProductTarget");
const PromotionIdFilter = value0 => $PromotionFilter(value0);
const ItemIdFilter = value0 => $ProductSingleFilter("ItemIdFilter", value0);
const ProductCategoryIdFilter = value0 => $ProductSingleFilter("ProductCategoryIdFilter", value0);
const ParameterValueFilter = value0 => value1 => $ProductSingleFilter("ParameterValueFilter", value0, value1);
const AnyComboFilter = /* #__PURE__ */ $ProductSingleFilter("AnyComboFilter");
const ProductPromotionRequirements = x => x;
const FreeProduct = x => x;
const Freeby = value0 => $PromotionPrize("Freeby", value0);
const PercentageDiscount = value0 => $PromotionPrize("PercentageDiscount", value0);
const PriceDiscount = value0 => $PromotionPrize("PriceDiscount", value0);
const CouponValue = /* #__PURE__ */ $PromotionPrize("CouponValue");
const TextInformation = /* #__PURE__ */ $PromotionPrize("TextInformation");
const CartValue = value0 => $CartPromotionRequirement("CartValue", value0);
const FirstOrder = /* #__PURE__ */ $CartPromotionRequirement("FirstOrder");
const Loyalty = /* #__PURE__ */ $CartPromotionRequirement("Loyalty");
const HasCoupon = /* #__PURE__ */ $CartPromotionRequirement("HasCoupon");
const Always = /* #__PURE__ */ $CartPromotionRequirement("Always");
const Never = /* #__PURE__ */ $CartPromotionRequirement("Never");
const CartPromotion = value0 => $PromotionConditions("CartPromotion", value0);
const ProductPromotion = value0 => $PromotionConditions("ProductPromotion", value0);
const newtypeProductPromotionRe = {Coercible0: () => {}};
const newtypeFreeProduct_ = {Coercible0: () => {}};
const hasFieldProductPromotionR = dictHasField => dictHasField;
const hasFieldFreeProduct = dictHasField => dictHasField;
const eqPromotionType = {
  eq: x => y => {
    if (x.tag === "Standard") { return y.tag === "Standard"; }
    if (x.tag === "InformationOnly") { return y.tag === "InformationOnly"; }
    if (x.tag === "RequiresCoupon") { return y.tag === "RequiresCoupon"; }
    return false;
  }
};
const ordPromotionType = {
  compare: x => y => {
    if (x.tag === "Standard") {
      if (y.tag === "Standard") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Standard") { return Data$dOrdering.GT; }
    if (x.tag === "InformationOnly") {
      if (y.tag === "InformationOnly") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "InformationOnly") { return Data$dOrdering.GT; }
    if (x.tag === "RequiresCoupon") {
      if (y.tag === "RequiresCoupon") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqPromotionType
};
const eqPromotionTarget = {
  eq: x => y => {
    if (x.tag === "CartTarget") { return y.tag === "CartTarget"; }
    if (x.tag === "ProductTarget") { return y.tag === "ProductTarget"; }
    return false;
  }
};
const ordPromotionTarget = {
  compare: x => y => {
    if (x.tag === "CartTarget") {
      if (y.tag === "CartTarget") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "CartTarget") { return Data$dOrdering.GT; }
    if (x.tag === "ProductTarget") {
      if (y.tag === "ProductTarget") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqPromotionTarget
};
const eqPromotionFilter = {eq: x => y => eq(x._1)(y._1)};
const eqProductSingleFilter = {
  eq: x => y => {
    if (x.tag === "ItemIdFilter") {
      if (y.tag === "ItemIdFilter") { return eq1(x._1)(y._1); }
      return false;
    }
    if (x.tag === "ProductCategoryIdFilter") {
      if (y.tag === "ProductCategoryIdFilter") { return eq2(x._1)(y._1); }
      return false;
    }
    if (x.tag === "ParameterValueFilter") {
      if (y.tag === "ParameterValueFilter") { return x._1 === y._1 && eq2(x._2)(y._2); }
      return false;
    }
    if (x.tag === "AnyComboFilter") { return y.tag === "AnyComboFilter"; }
    return false;
  }
};
const eq9 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(eqProductSingleFilter.eq))();
const ordProductSingleFilter = {
  compare: x => y => {
    if (x.tag === "ItemIdFilter") {
      if (y.tag === "ItemIdFilter") { return compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ItemIdFilter") { return Data$dOrdering.GT; }
    if (x.tag === "ProductCategoryIdFilter") {
      if (y.tag === "ProductCategoryIdFilter") { return compare1(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ProductCategoryIdFilter") { return Data$dOrdering.GT; }
    if (x.tag === "ParameterValueFilter") {
      if (y.tag === "ParameterValueFilter") {
        const v = Data$dOrd.ordString.compare(x._1)(y._1);
        if (v.tag === "LT") { return Data$dOrdering.LT; }
        if (v.tag === "GT") { return Data$dOrdering.GT; }
        return compare1(x._2)(y._2);
      }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ParameterValueFilter") { return Data$dOrdering.GT; }
    if (x.tag === "AnyComboFilter") {
      if (y.tag === "AnyComboFilter") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqProductSingleFilter
};
const compare4 = /* #__PURE__ */ (() => Data$dOrd.ordArray(ordProductSingleFilter).compare)();
const eqProductPromotionRequire = {eq: x => y => x.numRequiredItems === y.numRequiredItems && eq9(x.productFilter)(y.productFilter) && x.repeatable === y.repeatable};
const eqFreeProduct = {
  eq: x => y => x.productName === y.productName && x.productValue === y.productValue && (() => {
    if (x.vatRate.tag === "Nothing") { return y.vatRate.tag === "Nothing"; }
    if (x.vatRate.tag === "Just") {
      if (y.vatRate.tag === "Just") {
        if (x.vatRate._1.tag === "VatA") { return y.vatRate._1.tag === "VatA"; }
        if (x.vatRate._1.tag === "VatB") { return y.vatRate._1.tag === "VatB"; }
        if (x.vatRate._1.tag === "VatC") { return y.vatRate._1.tag === "VatC"; }
        if (x.vatRate._1.tag === "VatD") { return y.vatRate._1.tag === "VatD"; }
        if (x.vatRate._1.tag === "VatE") { return y.vatRate._1.tag === "VatE"; }
        if (x.vatRate._1.tag === "VatF") { return y.vatRate._1.tag === "VatF"; }
        if (x.vatRate._1.tag === "VatG") { return y.vatRate._1.tag === "VatG"; }
        return false;
      }
      return false;
    }
    return false;
  })()
};
const eq11 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(eqFreeProduct.eq))();
const eqPromotionPrize = {
  eq: x => y => {
    if (x.tag === "Freeby") {
      if (y.tag === "Freeby") { return eq11(x._1)(y._1); }
      return false;
    }
    if (x.tag === "PercentageDiscount") {
      if (y.tag === "PercentageDiscount") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "PriceDiscount") {
      if (y.tag === "PriceDiscount") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "CouponValue") { return y.tag === "CouponValue"; }
    if (x.tag === "TextInformation") { return y.tag === "TextInformation"; }
    return false;
  }
};
const eqCartPromotionRequiremen = {
  eq: x => y => {
    if (x.tag === "CartValue") {
      if (y.tag === "CartValue") { return x._1.minCartValue === y._1.minCartValue; }
      return false;
    }
    if (x.tag === "FirstOrder") { return y.tag === "FirstOrder"; }
    if (x.tag === "Loyalty") { return y.tag === "Loyalty"; }
    if (x.tag === "HasCoupon") { return y.tag === "HasCoupon"; }
    if (x.tag === "Always") { return y.tag === "Always"; }
    if (x.tag === "Never") { return y.tag === "Never"; }
    return false;
  }
};
const eqPromotionConditions = {
  eq: x => y => {
    if (x.tag === "CartPromotion") {
      if (y.tag === "CartPromotion") {
        if (x._1.tag === "CartValue") {
          if (y._1.tag === "CartValue") { return x._1._1.minCartValue === y._1._1.minCartValue; }
          return false;
        }
        if (x._1.tag === "FirstOrder") { return y._1.tag === "FirstOrder"; }
        if (x._1.tag === "Loyalty") { return y._1.tag === "Loyalty"; }
        if (x._1.tag === "HasCoupon") { return y._1.tag === "HasCoupon"; }
        if (x._1.tag === "Always") { return y._1.tag === "Always"; }
        if (x._1.tag === "Never") { return y._1.tag === "Never"; }
        return false;
      }
      return false;
    }
    if (x.tag === "ProductPromotion") {
      if (y.tag === "ProductPromotion") { return eqProductPromotionRequire.eq(x._1)(y._1); }
      return false;
    }
    return false;
  }
};
const genericPromotionType = {
  to: x => {
    if (x.tag === "Inl") { return Standard; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return InformationOnly; }
      if (x._1.tag === "Inr") { return RequiresCoupon; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Standard") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "InformationOnly") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "RequiresCoupon") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const showPromotionType = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(StandardIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(InformationOnlyIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(RequiresCouponIsSymbol);
    return x => {
      const $3 = genericPromotionType.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodePromotionType = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericPromotionType)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Standard"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("InformationOnly"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("RequiresCoupon"), Data$dGeneric$dRep.NoArguments)]})))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedPromotionType = /* #__PURE__ */ (() => (
  {
    top: genericPromotionType.to(Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))),
    bottom: genericPromotionType.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordPromotionType
  }
))();
const enumPromotionType = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericPromotionType)(genericEnumSum2),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericPromotionType)(genericEnumSum2),
  Ord0: () => ordPromotionType
};
const boundedEnumPromotionType = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum2["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericPromotionType)(genericBoundedEnumSum2),
    fromEnum: x => genericBoundedEnumSum2["genericFromEnum'"](genericPromotionType.from(x)),
    Bounded0: () => boundedPromotionType,
    Enum1: () => enumPromotionType
  }
))();
const genericPromotionTarget = {
  to: x => {
    if (x.tag === "Inl") { return CartTarget; }
    if (x.tag === "Inr") { return ProductTarget; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "CartTarget") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "ProductTarget") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showPromotionTarget = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CartTargetIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ProductTargetIsSymbol);
    return x => {
      if (x.tag === "CartTarget") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "ProductTarget") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodePromotionTarget = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericPromotionTarget)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("CartTarget"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("ProductTarget"), Data$dGeneric$dRep.NoArguments)]}))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedPromotionTarget = {top: ProductTarget, bottom: CartTarget, Ord0: () => ordPromotionTarget};
const enumPromotionTarget = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericPromotionTarget)(genericEnumSum1),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericPromotionTarget)(genericEnumSum1),
  Ord0: () => ordPromotionTarget
};
const boundedEnumPromotionTarge = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum1["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericPromotionTarget)(genericBoundedEnumSum1),
    fromEnum: x => genericBoundedEnumSum1["genericFromEnum'"]((() => {
      if (x.tag === "CartTarget") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "ProductTarget") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    })()),
    Bounded0: () => boundedPromotionTarget,
    Enum1: () => enumPromotionTarget
  }
))();
const genericPromotionPrize = {
  to: x => {
    if (x.tag === "Inl") { return $PromotionPrize("Freeby", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $PromotionPrize("PercentageDiscount", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $PromotionPrize("PriceDiscount", x._1._1._1); }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return CouponValue; }
          if (x._1._1._1.tag === "Inr") { return TextInformation; }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Freeby") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "PercentageDiscount") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "PriceDiscount") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "CouponValue") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "TextInformation") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))));
    }
    $runtime.fail();
  }
};
const genericPromotionFilter = {to: x => $PromotionFilter(x), from: x => x._1};
const showPromotionFilter = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dShow.showIntImpl);
      return {genericShowArgs: v => [$0(v)]};
    })())(PromotionIdFilterIsSymbol);
    return x => $0["genericShow'"](x._1);
  })()
};
const udecodePromotionFilter = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dGeneric.genericUnsafeDecodeTagged(genericPromotionFilter)(/* #__PURE__ */ Unscramble$dGeneric.genericDecodeSumConstruct(PromotionIdFilterIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Unscramble.decodeArray(Unscramble.decodeInt);
    return {unsafeDecodeSingleConstructorArgument: x => $0(x.contents)};
  })()))(Unscramble$dGeneric.defaultOptions)
};
const genericPromotionConditions = {
  to: x => {
    if (x.tag === "Inl") { return $PromotionConditions("CartPromotion", x._1); }
    if (x.tag === "Inr") { return $PromotionConditions("ProductPromotion", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "CartPromotion") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "ProductPromotion") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const genericProductSingleFilter = {
  to: x => {
    if (x.tag === "Inl") { return $ProductSingleFilter("ItemIdFilter", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $ProductSingleFilter("ProductCategoryIdFilter", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $ProductSingleFilter("ParameterValueFilter", x._1._1._1._1, x._1._1._1._2); }
        if (x._1._1.tag === "Inr") { return AnyComboFilter; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "ItemIdFilter") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "ProductCategoryIdFilter") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ParameterValueFilter") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.$Product(x._1, x._2))));
    }
    if (x.tag === "AnyComboFilter") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))); }
    $runtime.fail();
  }
};
const showProductSingleFilter = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dMenu$dV2$dTypes$dItemId.showItemId.show);
      return {genericShowArgs: v => [$0(v)]};
    })())(ItemIdFilterIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(genericShowArgsArgument)(ProductCategoryIdFilterIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [v]})(genericShowArgsArgument))(ParameterValueFilterIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(AnyComboFilterIsSymbol);
    return x => {
      const $4 = genericProductSingleFilter.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeProductSingleFilter = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ItemIdFilterIsSymbol)((() => {
      const $0 = Unscramble.decodeArray(Restaumatic$dMenu$dV2$dTypes$dItemId.unscrambleDecodeItemId.unsafeDecode);
      return {unsafeDecodeSingleConstructorArgument: x => $0(x.contents)};
    })()))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ProductCategoryIdFilterIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => decodeArray1.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd({
      argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(Data$dArray.unsafeIndexImpl(array, offset)))
    })({argsDecoder: Data$dTuple.$Tuple(1, offset => array => decodeArray1.unsafeDecode(Data$dArray.unsafeIndexImpl(array, offset)))})))(ParameterValueFilterIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(AnyComboFilterIsSymbol)))))(Unscramble$dGeneric.defaultOptions);
    return x => genericProductSingleFilter.to($0(x));
  })()
};
const genericProductPromotionRequirements = {to: x => x, from: x => x};
const showProductPromotionRequirements = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showProductSingleFilter.show);
      return {
        genericShowArgs: v => [
          "{ numRequiredItems: " + Data$dShow.showIntImpl(v.numRequiredItems) + ", productFilter: " + $0(v.productFilter) + (v.repeatable
            ? ", repeatable: true "
            : ", repeatable: false ") + "}"
        ]
      };
    })())(ProductPromotionRequirementsIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeProductPromotionRequirements = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(numRequiredItemsIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(productFilterIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeProductSingleFilter.unsafeDecode)
    })(Unscramble.decodeRecordCons(repeatableIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericFreeProduct = {to: x => x, from: x => x};
const showFreeProduct = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ productName: " + Data$dShow.showStringImpl(v.productName) + ", productValue: " + Data$dMoney$dRounded.toString(v.productValue) + (() => {
          if (v.vatRate.tag === "Just") { return ", vatRate: (Just " + Restaumatic$dMenu$dV2$dTypes$dVatRate.showVatRate.show(v.vatRate._1) + ") "; }
          if (v.vatRate.tag === "Nothing") { return ", vatRate: Nothing "; }
          $runtime.fail();
        })() + "}"
      ]
    })(FreeProductIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showPromotionPrize = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showFreeProduct.show);
      return {genericShowArgs: v => [$0(v)]};
    })())(FreebyIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showIntImpl(v)]})(PercentageDiscountIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dMoney$dRounded.toString(v)]})(PriceDiscountIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CouponValueIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(TextInformationIsSymbol);
    return x => {
      const $5 = genericPromotionPrize.from(x);
      if ($5.tag === "Inl") { return $0["genericShow'"]($5._1); }
      if ($5.tag === "Inr") {
        if ($5._1.tag === "Inl") { return $1["genericShow'"]($5._1._1); }
        if ($5._1.tag === "Inr") {
          if ($5._1._1.tag === "Inl") { return $2["genericShow'"]($5._1._1._1); }
          if ($5._1._1.tag === "Inr") {
            if ($5._1._1._1.tag === "Inl") { return $3["genericShow'"]($5._1._1._1._1); }
            if ($5._1._1._1.tag === "Inr") { return $4["genericShow'"]($5._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeFreeProduct = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(productNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(productValueIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons(vatRateIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dVatRate.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodePromotionPrize = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(FreebyIsSymbol)((() => {
      const $0 = Unscramble.decodeArray(unscrambleDecodeFreeProduct.unsafeDecode);
      return {unsafeDecodeSingleConstructorArgument: x => $0(x.contents)};
    })()))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(PercentageDiscountIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeInt(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(PriceDiscountIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Data$dInt.unsafeClamp(Data$dNumber.round(Unscramble.decodeNumber(x.contents) * 100.0))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(CouponValueIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(TextInformationIsSymbol))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericPromotionPrize.to($0(x));
  })()
};
const genericCartPromotionRequirement = {
  to: x => {
    if (x.tag === "Inl") { return $CartPromotionRequirement("CartValue", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return FirstOrder; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return Loyalty; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return HasCoupon; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return Always; }
            if (x._1._1._1._1.tag === "Inr") { return Never; }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "CartValue") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "FirstOrder") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Loyalty") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "HasCoupon") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "Always") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "Never") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
      );
    }
    $runtime.fail();
  }
};
const genericCompare = /* #__PURE__ */ (() => {
  const $0 = Data$dOrd$dGeneric.genericOrdSum((() => {
    const $0 = Data$dOrd.ordRecord()((() => {
      const eqRowCons2 = {eqRecord: v => ra => rb => ra.minCartValue === rb.minCartValue};
      return {
        compareRecord: v => ra => rb => {
          const left = Data$dOrd.ordInt.compare(ra.minCartValue)(rb.minCartValue);
          if (left.tag === "LT" || left.tag === "GT" || !(left.tag === "EQ")) { return left; }
          return Data$dOrdering.EQ;
        },
        EqRecord0: () => eqRowCons2
      };
    })());
    return {"genericCompare'": v => v1 => $0.compare(v)(v1)};
  })())(Data$dOrd$dGeneric.genericOrdSum(genericOrdConstructor)(Data$dOrd$dGeneric.genericOrdSum(genericOrdConstructor)(Data$dOrd$dGeneric.genericOrdSum(genericOrdConstructor)(Data$dOrd$dGeneric.genericOrdSum(genericOrdConstructor)(genericOrdConstructor)))));
  return x => y => $0["genericCompare'"](genericCartPromotionRequirement.from(x))(genericCartPromotionRequirement.from(y));
})();
const ordCartPromotionRequirement = {
  compare: v => v1 => {
    if (v1.tag === "CartValue") {
      if (v.tag === "CartValue") { return Data$dOrd.ordInt.compare(v._1.minCartValue)(v1._1.minCartValue); }
      return Data$dOrdering.LT;
    }
    if (v.tag === "CartValue") { return Data$dOrdering.GT; }
    return genericCompare(v)(v1);
  },
  Eq0: () => eqCartPromotionRequiremen
};
const ordPromotionConditions = {
  compare: v => v1 => {
    if (v.tag === "ProductPromotion") {
      if (v1.tag === "ProductPromotion") { return compare4(Data$dRecord.unsafeGet("productFilter")(v._1))(Data$dRecord.unsafeGet("productFilter")(v1._1)); }
      if (v1.tag === "CartPromotion") { return Data$dOrdering.LT; }
      $runtime.fail();
    }
    if (v.tag === "CartPromotion") {
      if (v1.tag === "ProductPromotion") { return Data$dOrdering.GT; }
      if (v1.tag === "CartPromotion") { return ordCartPromotionRequirement.compare(v._1)(v1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqPromotionConditions
};
const showCartPromotionRequirement = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ minCartValue: " + Data$dMoney$dRounded.toString(v.minCartValue) + " }"]})(CartValueIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(FirstOrderIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(LoyaltyIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(HasCouponIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(AlwaysIsSymbol);
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(NeverIsSymbol);
    return x => {
      const $6 = genericCartPromotionRequirement.from(x);
      if ($6.tag === "Inl") { return $0["genericShow'"]($6._1); }
      if ($6.tag === "Inr") {
        if ($6._1.tag === "Inl") { return $1["genericShow'"]($6._1._1); }
        if ($6._1.tag === "Inr") {
          if ($6._1._1.tag === "Inl") { return $2["genericShow'"]($6._1._1._1); }
          if ($6._1._1.tag === "Inr") {
            if ($6._1._1._1.tag === "Inl") { return $3["genericShow'"]($6._1._1._1._1); }
            if ($6._1._1._1.tag === "Inr") {
              if ($6._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($6._1._1._1._1._1); }
              if ($6._1._1._1._1.tag === "Inr") { return $5["genericShow'"]($6._1._1._1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const showPromotionConditions = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [showCartPromotionRequirement.show(v)]})(CartPromotionIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [showProductPromotionRequirements.show(v)]})(ProductPromotionIsSymbol);
    return x => {
      if (x.tag === "CartPromotion") { return $0["genericShow'"](x._1); }
      if (x.tag === "ProductPromotion") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeCartPromotionRequirement = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(CartValueIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(minCartValueIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(FirstOrderIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(LoyaltyIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(HasCouponIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(AlwaysIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(NeverIsSymbol)))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericCartPromotionRequirement.to($0(x));
  })()
};
const unscrambleDecodePromotionConditions = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(CartPromotionIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => unscrambleDecodeCartPromotionRequirement.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(ProductPromotionIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => unscrambleDecodeProductPromotionRequirements.unsafeDecode(x.contents)
    })))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $PromotionConditions("CartPromotion", $1._1); }
      if ($1.tag === "Inr") { return $PromotionConditions("ProductPromotion", $1._1); }
      $runtime.fail();
    };
  })()
};
const encodePromotionType = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericPromotionType)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("Standard"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("InformationOnly"); }
        if (v1._1.tag === "Inr") { return v.constructorTagTransform("RequiresCoupon"); }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const encodePromotionTarget = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericPromotionTarget)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("CartTarget"); }
      if (v1.tag === "Inr") { return v.constructorTagTransform("ProductTarget"); }
      $runtime.fail();
    }
  })
};
const encodePromotionFilter = {
  encode: /* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(PromotionIdFilterIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
      return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encode1(v)), Data$dList$dTypes.Nil)};
    })()).encodeOpts(Foreign$dGeneric$dClass.defaultOptions);
    return x => $0(x._1);
  })()
};
const encodeProductSingleFilter = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProductSingleFilter)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(ItemIdFilterIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dMenu$dV2$dTypes$dItemId.encodeItemId.encode);
      return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encode1(v)), Data$dList$dTypes.Nil)};
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(ProductCategoryIdFilterIsSymbol)(genericEncodeArgsArgument);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(ParameterValueFilterIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    })(genericEncodeArgsArgument));
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(AnyComboFilterIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeProductPromotionRequirements = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProductPromotionRequirements)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ProductPromotionRequirementsIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(repeatableIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(productFilterIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeProductSingleFilter.encode);
      return {encodeWithOptions: v => encode1};
    })()))(numRequiredItemsIsSymbol)(encodeWithOptionsOther);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeFreeProduct = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericFreeProduct)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(FreeProductIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(vatRateIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dVatRate.encodeVatRate.encode(v2._1); }
        $runtime.fail();
      }
    }))(productValueIsSymbol)(encodeWithOptionsOther1))(productNameIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodePromotionPrize = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPromotionPrize)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(FreebyIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeFreeProduct.encode);
      return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encode1(v)), Data$dList$dTypes.Nil)};
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(PercentageDiscountIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(PriceDiscountIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", Data$dInt.toNumber(v) / 100.0), Data$dList$dTypes.Nil)
    });
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(CouponValueIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor(TextInformationIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") {
              if (v1._1._1._1.tag === "Inl") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              if (v1._1._1._1.tag === "Inr") { return $4.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeCartPromotionRequirement = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCartPromotionRequirement)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(CartValueIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(minCartValueIsSymbol)(encodeWithOptionsOther1);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(FirstOrderIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(LoyaltyIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(HasCouponIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor(AlwaysIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor(NeverIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") {
              if (v1._1._1._1.tag === "Inl") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              if (v1._1._1._1.tag === "Inr") {
                if (v1._1._1._1._1.tag === "Inl") { return $4.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1); }
                if (v1._1._1._1._1.tag === "Inr") { return $5.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1); }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodePromotionConditions = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPromotionConditions)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(CartPromotionIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeCartPromotionRequirement.encode(v)), Data$dList$dTypes.Nil)
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(ProductPromotionIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeProductPromotionRequirements.encode(v)), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        $runtime.fail();
      }
    };
  })())
};
const decodePromotionType = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericPromotionType)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(StandardIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(InformationOnlyIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(RequiresCouponIsSymbol))))
};
const decodePromotionTarget = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericPromotionTarget)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(CartTargetIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ProductTargetIsSymbol)))
};
const decodePromotionFilter = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericPromotionFilter)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PromotionIdFilterIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(/* #__PURE__ */ (() => {
      const decode2 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.intDecode).decode;
      return {decodeWithOptions: v => decode2};
    })()),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(Foreign$dGeneric$dClass.defaultOptions)
};
const decodeProductSingleFilter = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProductSingleFilter)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ItemIdFilterIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(/* #__PURE__ */ (() => {
      const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dMenu$dV2$dTypes$dItemId.decodeItemId).decode;
      return {decodeWithOptions: v => decode2};
    })()),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductCategoryIdFilterIsSymbol)(genericDecodeArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ParameterValueFilterIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsProduct({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(genericDecodeArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(AnyComboFilterIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))
};
const decodeProductPromotionRequirements = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProductPromotionRequirements)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductPromotionRequirementsIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(repeatableIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode
  })())(productFilterIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeProductSingleFilter).decode;
    return {decodeWithOptions: v => decode2};
  })())())(numRequiredItemsIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeFreeProduct = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericFreeProduct)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FreeProductIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(vatRateIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dVatRate.decodeVatRate.decode)
  })())(productValueIsSymbol)(decodeWithOptionsOther1)())(productNameIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodePromotionPrize = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPromotionPrize)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FreebyIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(/* #__PURE__ */ (() => {
      const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeFreeProduct).decode;
      return {decodeWithOptions: v => decode2};
    })()),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PercentageDiscountIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PriceDiscountIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther1),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CouponValueIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(TextInformationIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))))))
};
const decodeCartPromotionRequirement = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCartPromotionRequirement)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CartValueIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(minCartValueIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FirstOrderIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(LoyaltyIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(HasCouponIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(AlwaysIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(NeverIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))))
};
const decodePromotionConditions = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPromotionConditions)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CartPromotionIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeCartPromotionRequirement.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductPromotionIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeProductPromotionRequirements.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument)))
};
export {
  $CartPromotionRequirement,
  $ProductSingleFilter,
  $PromotionConditions,
  $PromotionFilter,
  $PromotionPrize,
  $PromotionTarget,
  $PromotionType,
  Always,
  AlwaysIsSymbol,
  AnyComboFilter,
  AnyComboFilterIsSymbol,
  CartPromotion,
  CartPromotionIsSymbol,
  CartTarget,
  CartTargetIsSymbol,
  CartValue,
  CartValueIsSymbol,
  CouponValue,
  CouponValueIsSymbol,
  FirstOrder,
  FirstOrderIsSymbol,
  FreeProduct,
  FreeProductIsSymbol,
  Freeby,
  FreebyIsSymbol,
  HasCoupon,
  HasCouponIsSymbol,
  InformationOnly,
  InformationOnlyIsSymbol,
  ItemIdFilter,
  ItemIdFilterIsSymbol,
  Loyalty,
  LoyaltyIsSymbol,
  Never,
  NeverIsSymbol,
  ParameterValueFilter,
  ParameterValueFilterIsSymbol,
  PercentageDiscount,
  PercentageDiscountIsSymbol,
  PriceDiscount,
  PriceDiscountIsSymbol,
  ProductCategoryIdFilter,
  ProductCategoryIdFilterIsSymbol,
  ProductPromotion,
  ProductPromotionIsSymbol,
  ProductPromotionRequirements,
  ProductPromotionRequirementsIsSymbol,
  ProductTarget,
  ProductTargetIsSymbol,
  PromotionIdFilter,
  PromotionIdFilterIsSymbol,
  RequiresCoupon,
  RequiresCouponIsSymbol,
  Standard,
  StandardIsSymbol,
  TextInformation,
  TextInformationIsSymbol,
  boundedEnumPromotionTarge,
  boundedEnumPromotionType,
  boundedPromotionTarget,
  boundedPromotionType,
  compare,
  compare1,
  compare4,
  decodeArray1,
  decodeCartPromotionRequirement,
  decodeFreeProduct,
  decodeProductPromotionRequirements,
  decodeProductSingleFilter,
  decodePromotionConditions,
  decodePromotionFilter,
  decodePromotionPrize,
  decodePromotionTarget,
  decodePromotionType,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  encodeCartPromotionRequirement,
  encodeFreeProduct,
  encodeProductPromotionRequirements,
  encodeProductSingleFilter,
  encodePromotionConditions,
  encodePromotionFilter,
  encodePromotionPrize,
  encodePromotionTarget,
  encodePromotionType,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  enumPromotionTarget,
  enumPromotionType,
  eq,
  eq1,
  eq11,
  eq2,
  eq9,
  eqCartPromotionRequiremen,
  eqFreeProduct,
  eqProductPromotionRequire,
  eqProductSingleFilter,
  eqPromotionConditions,
  eqPromotionFilter,
  eqPromotionPrize,
  eqPromotionTarget,
  eqPromotionType,
  genericBottomConstructor,
  genericBottomSum,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericBoundedEnumSum1,
  genericBoundedEnumSum2,
  genericCartPromotionRequirement,
  genericCompare,
  genericDecodeArgsArgument,
  genericEncodeArgsArgument,
  genericEnumConstructor,
  genericEnumSum,
  genericEnumSum1,
  genericEnumSum2,
  genericFreeProduct,
  genericOrdConstructor,
  genericProductPromotionRequirements,
  genericProductSingleFilter,
  genericPromotionConditions,
  genericPromotionFilter,
  genericPromotionPrize,
  genericPromotionTarget,
  genericPromotionType,
  genericShowArgsArgument,
  genericTopConstructor,
  hasFieldFreeProduct,
  hasFieldProductPromotionR,
  minCartValueIsSymbol,
  newtypeFreeProduct_,
  newtypeProductPromotionRe,
  numRequiredItemsIsSymbol,
  ordCartPromotionRequirement,
  ordProductSingleFilter,
  ordPromotionConditions,
  ordPromotionTarget,
  ordPromotionType,
  productFilterIsSymbol,
  productNameIsSymbol,
  productValueIsSymbol,
  repeatableIsSymbol,
  showCartPromotionRequirement,
  showFreeProduct,
  showProductPromotionRequirements,
  showProductSingleFilter,
  showPromotionConditions,
  showPromotionFilter,
  showPromotionPrize,
  showPromotionTarget,
  showPromotionType,
  udecodePromotionFilter,
  unscrambleDecodeCartPromotionRequirement,
  unscrambleDecodeFreeProduct,
  unscrambleDecodeProductPromotionRequirements,
  unscrambleDecodeProductSingleFilter,
  unscrambleDecodePromotionConditions,
  unscrambleDecodePromotionPrize,
  unscrambleDecodePromotionTarget,
  unscrambleDecodePromotionType,
  vatRateIsSymbol
};
